import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SpeakerFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4453 3.16795C11.7853 2.93871 12.2147 2.93871 12.5547 3.16795C12.8323 3.35513 13 3.66839 13 4V20C13 20.3316 12.8323 20.6449 12.5547 20.8321C12.2147 21.0613 11.7853 21.0613 11.4453 20.8321C11.2773 20.7188 10.9728 20.4974 10.5963 20.2192C9.94714 19.7396 9.0826 19.0976 8.30715 18.5103C7.66236 18.0221 7.05222 17.5557 6.6688 17.2616C6.61531 17.2206 6.5559 17.1749 6.5 17.1318V6.86824C6.5559 6.82511 6.61531 6.77944 6.6688 6.73841C7.05222 6.4443 7.66236 5.97788 8.30715 5.48969C9.0826 4.90242 9.94714 4.26039 10.5963 3.78083C10.9728 3.50261 11.2773 3.28118 11.4453 3.16795Z"
      fill="currentColor"
    />
    <path
      d="M5 7H3C2.44772 7 2 7.44772 2 8V16C2 16.5523 2.44772 17 3 17H5V7Z"
      fill="currentColor"
    />
    <path
      d="M16.5355 7.46447C16.145 7.07394 15.5118 7.07394 15.1213 7.46447C14.7308 7.85499 14.7308 8.48816 15.1213 8.87868C15.9 9.65736 16.25 10.7574 16.25 12C16.25 13.2426 15.9 14.3426 15.1213 15.1213C14.7308 15.5118 14.7308 16.145 15.1213 16.5355C15.5118 16.9261 16.145 16.9261 16.5355 16.5355C17.7 15.371 18.25 13.7574 18.25 12C18.25 10.2426 17.7 8.62893 16.5355 7.46447Z"
      fill="currentColor"
    />
    <path
      d="M19.364 4.63604C18.9734 4.24551 18.3403 4.24551 17.9497 4.63604C17.5592 5.02656 17.5592 5.65973 17.9497 6.05025C19.5286 7.62914 20.25 9.74264 20.25 12C20.25 14.2574 19.5286 16.3709 17.9497 17.9497C17.5592 18.3403 17.5592 18.9734 17.9497 19.364C18.3403 19.7545 18.9734 19.7545 19.364 19.364C21.3214 17.4066 22.25 14.7426 22.25 12C22.25 9.25736 21.3214 6.59343 19.364 4.63604Z"
      fill="currentColor"
    />
  </svg>
);

SpeakerFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SpeakerFilledIcon);
